import React, { useEffect, useState } from 'react';
import UserDashboard from './UserDashboard';

const OfficeProfile = () => {
  const [worker, setWorker] = useState(null);

  useEffect(() => {
    const storedWorker = localStorage.getItem('worker');
    if (storedWorker) {
      setWorker(JSON.parse(storedWorker));
    }
  }, []);

  if (!worker) return <p className="text-center mt-10 text-gray-500">Loading profile...</p>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 to-pink-100">
        <UserDashboard />
      <div className="bg-white shadow-xl rounded-2xl p-10 w-full max-w-md flex flex-col items-center">
        <img
          src={worker.profileImage?.replace(/\\/g, '/')}
          alt="Profile"
          className="w-32 h-32 rounded-full border-4 border-yellow-400 object-cover mb-6"
        />

        <div className="text-center text-gray-800 text-lg space-y-4">
          <p><span className="font-semibold">Name :</span> {worker.username}</p>
          <p><span className="font-semibold">Company Name :</span> {worker.company}</p>
          <p><span className="font-semibold">Role :</span> {worker.role}</p>
          <p><span className="font-semibold">Work Mode :</span> {worker.workMode}</p>
          <p><span className="font-semibold">Email :</span> {worker.email}</p>
          <p><span className="font-semibold">Mobile No :</span> {worker.mobile}</p>
        </div>

      </div>
    </div>
  );
};

export default OfficeProfile;
